import React from 'react';
import LegalPageLayout from '@/components/landing/LegalPageLayout';
import { useI18n } from '@/lib/I18nContext';

const LAST_UPDATED = '12 de junio de 2026';

/* Parses **bold** markers into <strong> elements */
function LegalText({ text }) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return <span key={i}>{part}</span>;
  });
}

export default function DataDeletion() {
  const { t } = useI18n();
  const P = 'legal.data_deletion.';

  return (
    <LegalPageLayout title={t('legal.data_deletion_title', 'Eliminación de datos — Bezkraen')} lastUpdated={LAST_UPDATED}>
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-10 text-sm text-blue-800">
        <LegalText text={t(P + 'info', '')} />
      </div>

      <section className="mb-10">
        <h2 className="font-heading font-bold text-gray-900 mb-4" style={{ fontSize: '1.15rem', lineHeight: 1.3 }}>
          {t(P + 's1_title', '')}
        </h2>
        <div className="space-y-3">
          <p><LegalText text={t(P + 's1_p1', '')} /></p>
          <ul>
            {t(P + 's1_list1', '').split('|').map((item, i) => <li key={i}>{item}</li>)}
          </ul>
          <p><LegalText text={t(P + 's1_p2', '')} /></p>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading font-bold text-gray-900 mb-4" style={{ fontSize: '1.15rem', lineHeight: 1.3 }}>
          {t(P + 's2_title', '')}
        </h2>
        <div className="space-y-3">
          <p><LegalText text={t(P + 's2_p1', '')} /></p>
          <ul>
            {t(P + 's2_list1', '').split('|').map((item, i) => <li key={i}><LegalText text={item} /></li>)}
          </ul>
          <p><LegalText text={t(P + 's2_p2', '')} /></p>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading font-bold text-gray-900 mb-4" style={{ fontSize: '1.15rem', lineHeight: 1.3 }}>
          {t(P + 's3_title', '')}
        </h2>
        <div className="space-y-3">
          <p><LegalText text={t(P + 's3_p1', '')} /></p>
          <ul>
            {t(P + 's3_list1', '').split('|').map((item, i) => <li key={i}>{item}</li>)}
          </ul>
          <p><LegalText text={t(P + 's3_p2', '')} /></p>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading font-bold text-gray-900 mb-4" style={{ fontSize: '1.15rem', lineHeight: 1.3 }}>
          {t(P + 's4_title', '')}
        </h2>
        <div className="bg-gray-50 rounded-xl p-5 border border-gray-100 not-prose">
          <p className="font-semibold text-gray-800" style={{ fontSize: 15 }}>Bezkraen E.I.R.L.</p>
          <p className="text-gray-600" style={{ fontSize: 14 }}>{t('legal.contact.rut_label', '')} 78.504.242-5</p>
          <p className="text-gray-600" style={{ fontSize: 14 }}>{t('legal.contact.address_label', '')} Antonio Bellet 193, Of. 1210, Providencia, Santiago, Chile</p>
          <p className="text-gray-600" style={{ fontSize: 14 }}>{t('legal.contact.privacy_email_label', '')} ventas@bezkraen.com</p>
          <p className="text-gray-600" style={{ fontSize: 14 }}>{t('legal.contact.website_label', '')} bezkraen.com</p>
          <p className="text-gray-600" style={{ fontSize: 14 }}>{t('legal.contact.jurisdiction_label', '')} Chile</p>
        </div>
      </section>

      <p className="text-sm text-gray-400">
        {t(P + 'footer_before', '')}
        <a href="/privacy-policy" className="text-blue-600 underline">{t(P + 'footer_link_privacy', '')}</a>
        {t(P + 'footer_middle', '')}
        <a href="/terms-of-service" className="text-blue-600 underline">{t(P + 'footer_link_terms', '')}</a>
        {t(P + 'footer_after', '')}
      </p>
    </LegalPageLayout>
  );
}